/* eslint-disable no-underscore-dangle */

import permission from './permission';
import route from './route';

export default {
  state: {
    data: {},
    order: [],
    loading: false,
    error: null,
    queue: [],
    config: {
      default: 'PRODUCT',
      append: '_PERMISSION_GROUP',
      path: 'product/group',
      error: { active: false },
      get: { active: false, msg: '' },
      update: { active: false, msg: 'Subprodukt aktualisiert.' },
      create: { active: false, msg: 'Subprodukt erstellt.' },
      delete: { active: false, msg: 'Subprodukt gelöscht.' },
      admin: {
        error: { active: true },
        get: { active: true, msg: '' },
        update: { active: true, msg: 'Subprodukt aktualisiert.' },
        create: { active: true, msg: 'Subprodukt erstellt.' },
        delete: { active: true, msg: 'Subprodukt gelöscht.' },
      },
    },
  },
  getters: {
    dataByParentId: (state) => (id) => {
      // eslint-disable-next-line camelcase
      const { permission_groups } = state.data[id] || { permission_groups: [] };
      // eslint-disable-next-line camelcase
      return permission_groups;
    },
  },
  mutations: {},
  actions: {
    SOCKET_PRODUCT_PERMISSION_GROUPS({ dispatch, getters }, payload) {
      if (process.env.NODE_ENV !== 'production') {
        console.log(`[${getters.config.path}] SOCKET_PRODUCT_PERMISSION_GROUPS`, payload);
      }
      dispatch('HANDLE_PAYLOAD', payload[1]);

      for (let i = 0; i < payload[1].permission_groups.length; i += 1) {
        const element = payload[1].permission_groups[i];
        dispatch('route/GET', {
          payload: { id: element.id, product_id: element.product_id },
          multi: true,
        });
      }

      // commit('SET_LOADING', false);
    },
  },
  modules: {
    route: { ...route, namespaced: true },
    permission: { ...permission, namespaced: true },
  },
};
